module.exports = {
    "baseUrl": "https://api-v4.staging.iris-health.com",
    "baseUrl2": "",
    "dashboardUrl": "",
    "systemName": "System dev",
    "newChatServer": "https://chat.staging.iris-health.com",
    "prodStatus": true,
    "patientChatUrl": "https://patientchat.staging.iris-health.com",
    "stripeKey": "pk_test_51Ia02yIg43ZjHHGkNp1xNEhAYWFGkVQQBSKrNy9zCbK82wjPXTq7mROyYGjQd23qTEjiJt9zTaQHEVos9Ty4eXd700iya1BPmo",
    "companyTitle": "Clinic Scheduler | Iris Health",
    "metaTitle": "Iris Health Scheduler Web App",
    "metaDescription": "Scheduler for physicians and clinics from Iris Health",
    "favicon": "%PUBLIC_URL%/iris-health-logo.jpeg",
    "companyName": "Iris Health",
    "copyRight": "Iris Health is a trademark of its respective owner.",
    "companyKey": "iris",
    "aboutHref": "https://www.iris-health.com/about/",
    "contactHref": "https://www.iris-health.com/contact-us/",
    "selfPayApi": "https://app.staging.iris-health.com"
}